import { useSyncExternalStore } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { Radio } from 'lucide-react';
import { useLiveChannel, liveHub } from '../../lib/realtime';
import { t } from '../../lib/i18n';

/**
 * Keeps device pages fresh. A `devices` message for the site (after each health report or alert change)
 * refetches the device queries; after a dropped connection returns, everything is refetched.
 */
function SiteLive({ siteId }: { siteId: string }) {
  const qc = useQueryClient();
  const refresh = () => void qc.invalidateQueries({ queryKey: ['devices'] });
  useLiveChannel('devices', siteId, refresh, refresh);
  return null;
}

export function DevicesLive({ siteIds }: { siteIds: string[] }) {
  const connected = useSyncExternalStore(liveHub.onChange, liveHub.getConnected, () => false);
  return (
    <>
      {siteIds.map((id) => (
        <SiteLive key={id} siteId={id} />
      ))}
      <p role="status" className="mb-3 inline-flex items-center gap-1.5 text-xs text-slate-600">
        <Radio aria-hidden="true" className={`h-3.5 w-3.5 ${connected ? 'text-green-700' : 'text-amber-700'}`} />
        {connected ? t('devicesUi.live.on') : t('devicesUi.live.off')}
      </p>
    </>
  );
}
